// 画像のサイズをチェックするユーティリティ

export interface ImageDimensions {
  width: number;
  height: number;
}

// 画像のサイズを取得する関数
export const getImageDimensions = (src: string): Promise<ImageDimensions> => {
  return new Promise((resolve, reject) => {
    const img = new Image();

    img.onload = () => {
      resolve({
        width: img.naturalWidth,
        height: img.naturalHeight,
      });
    };

    img.onerror = () => {
      reject(new Error(`Failed to load image: ${src}`));
    };

    img.src = src;
  });
};

// 画像が最小サイズ要件を満たしているかチェック
export const isImageSizeValid = async (
  src: string,
  minWidth: number = 100,
  minHeight: number = 100
): Promise<boolean> => {
  try {
    const dimensions = await getImageDimensions(src);
    return dimensions.width >= minWidth && dimensions.height >= minHeight;
  } catch (error) {
    console.warn(`Image validation failed for ${src}:`, error);
    return false;
  }
};

// 画像配列から有効なサイズの画像のみをフィルタリング
export const filterValidSizeImages = async (
  images: string[],
  minWidth: number = 100,
  minHeight: number = 100
): Promise<string[]> => {
  const validationPromises = images.map(async src => {
    const isValid = await isImageSizeValid(src, minWidth, minHeight);
    return isValid ? src : null;
  });

  const results = await Promise.all(validationPromises);
  return results.filter((src): src is string => src !== null);
};
